import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatTableModule } from "@angular/material";

@NgModule({
  declarations: [],
  imports: [
    CommonModule,  
    MatTableModule,
      
  ],
  exports: []
})
export class AppModule { }
